import { useSelector } from 'react-redux';
import { getInstallPromptEvent } from '../selectors/window';

const useInstallPromptEvent = () => {
	return useSelector(getInstallPromptEvent);
}

export default useInstallPromptEvent;